import React, { useState } from 'react';
import { usePostChangePassword } from '../../hooks/react-query/useUserData';
import PasswordChangeForm from './passwordChangeForm';
import { useNavigate } from 'react-router-dom';

const Account = () => {
  const navigate = useNavigate();

  const [serverError, setServerError] = useState();

  const { mutate } = usePostChangePassword();

  const handlePasswordReset = (payload) => {
    mutate(payload, {
      onSuccess: (data) => {
        if (data && data.data.status === 'fail') {
          if (data.exceptions && data.exceptions.length) {
            setServerError(data.exceptions[0]);
          }
        } else if (data && data.data.status === 'success') {
          navigate('/');
        }
      },
    });
  };

  return (
    <PasswordChangeForm
      serverError={serverError}
      handleSubmit={handlePasswordReset}
      title={'Αλλαγή Κωδικού'}
      setServerError={setServerError}
      handleClick={() => navigate(-1)}
    />
  );
};

export default Account;
